export default __webpack_public_path__ + "static/media/Average-Waiver-Extension.3cecc21d.pdf";